import React from 'react';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // If it's a known transient Firestore SDK transport bug, do not crash the component tree
        if (error?.message?.includes('INTERNAL ASSERTION FAILED') || String(error)?.includes('INTERNAL ASSERTION FAILED')) {
            console.warn('[Oblique ErrorBoundary] Suppressed Firestore internal SDK assertion failure:', error);
            return { hasError: false, error: null, errorInfo: null };
        }
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service like Sentry
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="p-6 m-4 rounded-2xl bg-[var(--bg-subtle,#f8f9fa)] border border-[var(--border-destructive,#fecaca)] text-[var(--text-primary,#111827)]">
                    <h2 className="text-lg font-semibold text-[var(--text-destructive,#ef4444)] mb-2">Something went wrong.</h2>
                    <p className="text-sm text-[var(--text-secondary,#4b5563)] mb-4">
                        This specific module crashed, but the rest of the application is still running.
                    </p>
                    <button 
                        onClick={() => this.setState({ hasError: false })}
                        className="py-2 px-4 bg-[var(--text-primary,#111827)] text-[var(--bg-surface,#ffffff)] border-none rounded-lg cursor-pointer text-[13px] font-medium hover:opacity-90 transition-opacity"
                    >
                        Try Again
                    </button>
                    {import.meta.env.DEV && (
                        <details className="whitespace-pre-wrap mt-4 text-xs text-[var(--text-tertiary,#9ca3af)] bg-[var(--bg-surface,#ffffff)] p-3 rounded-lg border border-[var(--border)]">
                            {this.state.error && this.state.error.toString()}
                            <br />
                            {this.state.errorInfo && this.state.errorInfo.componentStack}
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children; 
    }
}
